import type { ErrorObject, Validation } from '@vuelidate/core'
import type { Ref } from 'vue'
import { computed } from 'vue'

export type ValidationMessages = { [key: string]: string }

export function useValidationMessages(v$: Ref<Validation>) {
  const errorMessages = computed((): ValidationMessages => {
    return extractValidationMessages(v$.value)
  })

  function extractValidationMessages(errors: Validation, prefix = '') {
    const messages: ValidationMessages = {}

    for (const error of errors.$errors) {
      const propertyPath = prefix + error.$propertyPath

      if (error.$validator === '$each' && error.$response && error.$response.$errors) {
        ;(error.$response.$errors as ErrorObject[]).forEach((itemError, index) => {
          const nestedPrefix = `${propertyPath}.${index}.`
          for (const key in itemError) {
            const nestedMessages = extractValidationMessages(
              {
                $errors: [
                  {
                    $propertyPath: key,
                    $message: itemError[key as keyof ErrorObject][0]?.$message || '',
                    $response: itemError[key as keyof ErrorObject][0]?.$response,
                    $validator: itemError[key as keyof ErrorObject][0]?.$validator,
                  },
                ],
              } as Validation,
              nestedPrefix,
            )
            Object.assign(messages, nestedMessages)
          }
        })
      } else {
        messages[propertyPath] = error.$message as string
      }
    }

    for (const key in messages) {
      if (messages[key].trim() === '') {
        delete messages[key]
      }
    }

    return messages
  }

  return { errorMessages }
}
